function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useEffect } from 'react';
import VideoOverlay from './VideoOverlay.react';
var Video = function Video(_ref) {
  var id = _ref.id,
    src = _ref.src,
    active = _ref.active,
    overlay = _ref.overlay,
    placeholder = _ref.placeholder,
    _onEnded = _ref.onEnded;
  useEffect(function () {
    if (active === id) $("#".concat(id)).css({
      opacity: 1
    });
  }, []);
  useEffect(function () {
    var vid = document.getElementById("vid".concat(id));
    if (active === id) {
      vid.currentTime = 0;
      vid.play();
      $("#".concat(id)).css({
        opacity: 1
      });
    } else {
      vid.pause();
      $("#".concat(id)).css({
        opacity: 0
      });
    }
  }, [active]);
  return /*#__PURE__*/React.createElement("div", {
    className: "video",
    id: id,
    style: {
      zIndex: id === active ? 2 : 1
    }
  }, /*#__PURE__*/React.createElement("video", {
    id: "vid".concat(id),
    muted: true,
    playsInline: true,
    poster: "/public/videos/".concat(placeholder),
    onEnded: function onEnded() {
      return _onEnded(id);
    }
  }, /*#__PURE__*/React.createElement("source", {
    src: "/public/videos/".concat(src),
    type: "video/mp4"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/videos/".concat(placeholder),
    title: "Your browser does not support this video."
  })), overlay && /*#__PURE__*/React.createElement(VideoOverlay, _extends({}, overlay, {
    active: active,
    id: id
  })));
};
export default Video;